import { CassetteChockPage } from "./CassetteChockPage";

const CassetteChock = () => {
	return <CassetteChockPage />;
};
export default CassetteChock;
